<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" class="juli">
      <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/map_mn/Map_mn' }">地图管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/map_mn/Line_mn' }">线路管理</el-breadcrumb-item>
      <el-breadcrumb-item>站点管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="站点详情" name="first" v-if="check_auth('/web/station/get_stations')">
        <el-table :data="tableData" border style="width: 100%">
          <!-- <el-table-column label="ID" align="center" width="80">
            <template slot-scope="scope">
              <span v-text="scope.$index + 1"></span>
            </template>
          </el-table-column> -->
          <el-table-column prop="id" label="站点编号" align="center" width="180">
          </el-table-column>
          <el-table-column prop="name_cn" label="站点名称" align="center">
          </el-table-column>
          <el-table-column prop="createtime" align="center" label="创建时间">
          </el-table-column>
          <el-table-column prop="updatetime" align="center" label="更新时间">
          </el-table-column>
        </el-table>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </el-tab-pane>
      <el-tab-pane label="站点地图" name="second" v-if="check_auth('/web/line/line_detail')">
        <div id="containermap"></div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  get_station_list,
  get_station_one,
  get_line_detail,
} from "../../api/station/station";
import { auth } from "../../utils/util";
import Pagination from "../../components/Pagination";
let conmap = "";
import AMap from "AMap";
export default {
  data() {
    return {
      activeName: "first",
      dialogFormVisible: false,
      map: null,
      tableData: [],
      linePath: [],
      formInline: {
        page: 1,
        limit: 10,
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      form: {
        station_id: "",
        name: "",
        name_cn: "",
        create_time: "",
        update_time: "",
        remark: "",
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 创建完毕
   */
  created() {
    this.getData();
    this.activeName = "first";
  },
  destroyed() {
    conmap.destroy();
  },
  methods: {
    handleClick() {
      if (this.activeName == "frist") {
        this.formInline.page = 1
        this.getData();
      }
      if (this.activeName == "second") {
        this.createMap();
      }
    },
    async getMapStation() {
      return get_line_detail().then((res) => {
        if (res["code"] === 0) {
          this.linePath = res.data;
        }
      });
    },
    check_auth(val) {
      return auth(val);
    },
    async createMap() {
      await this.getMapStation();
      //创建地图
      conmap = new AMap.Map("containermap", {
        resizeEnable: true, //是否监控地图容器尺寸变化
        zoom: 25, //初始化地图层级
        center: [118.054994, 36.813787], //初始化地图中心点
      });
      this.guiji();
    },
    guiji() {
      let a = [];
      let lnglat = [];
      let _path = [];
      a = this.linePath;

      for (let i = 0; i < a.length; i++) {
        lnglat.push(new AMap.LngLat(parseFloat(a[i]["lon"]), parseFloat(a[i]["lat"])));
      }
      AMap.convertFrom(lnglat, 'gps', function (status, result) {
        if (result.info === 'ok') {
          var resLnglat = result.locations;
          for (let i = 0; i < resLnglat.length; i++) {
            _path.push([resLnglat[i].lng, resLnglat[i].lat]);
          }
          AMapUI.load(
            ["ui/misc/PathSimplifier", "lib/$"],
            function (PathSimplifier, $) {
              if (!PathSimplifier.supportCanvas) {
                alert("当前环境不支持 Canvas！");
                return;
              }

              var pathSimplifierIns = new PathSimplifier({
                zIndex: 10,
                //autoSetFitView:false,
                map: conmap, //所属的地图实例

                getPath: function (pathData, pathIndex) {
                  return pathData.path;
                },
                getHoverTitle: function (pathData, pathIndex, pointIndex) {
                  if (pointIndex >= 0) {
                    //point
                    return (
                      pathData.line_name +
                      "，点：" +
                      pointIndex +
                      "/" +
                      pathData.path.length
                    );
                  }

                  return pathData.line_name + "，点数量" + pathData.path.length;
                },
                renderOptions: {
                  renderAllPointsIfNumberBelow: 100, //绘制路线节点，如不需要可设置为-1
                },
              });
              window.pathSimplifierIns = pathSimplifierIns;

              //设置数据

              pathSimplifierIns.setData([
                {
                  line_name: "路线0",
                  path: _path,
                },
              ]);

              //对第一条线路（即索引 0）创建一个巡航器
              var navg1 = pathSimplifierIns.createPathNavigator(0, {
                loop: true, //循环播放
                speed: 100, //巡航速度，单位千米/小时
              });

              navg1.start();
            }
          );
        }
      });

    },

    // 站点列表
    getData() {
      get_station_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          this.tableData = res.data.data;
          for (var i = 0; i < this.tableData.length; i++) {
            this.tableData[i].status =
              this.tableData[i].status === 1 ? true : false;
          }
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res.data["total"];
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getData();
    },
    // 获取单个站点
    editStation(row) {
      this.dialogFormVisible = true;
      get_station_one(row.station_id).then((res) => {
        if (res["code"] === 0) {
          this.form = res.data;
        }
      });
    },
    closeDialog() {
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style>
#containermap {
  width: 100%;
  height: 800px;
}

.juli {
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/map_mn/Station_mn.vue